export enum Currency {
  USD = 'USD',
  MXN = 'MXN',
}

export default interface Money {
  value: number;
  currency: Currency;
}
